

export const getAPIUrl = (path) => {
    const { host, protocol } = window.location;

    if (process.env.REACT_APP_API_HOST) {
        return `${process.env.REACT_APP_API_HOST}/${path}`;
    }

    return `${protocol}//api.${host}/${path}`;
}
